import './App.css';
import AppRoutes from './routes/routes';
import './common.css'
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { BrowserRouter as Router} from "react-router-dom";
import AuthWatcher from './components/authWatcher';
import { Suspense } from 'react';

function App() {
  return (
    <div >
      <Router>
        <AuthWatcher />
        <Suspense>
          <AppRoutes />
          <ToastContainer />
        </Suspense>
      </Router>
    </div>
  );
}

export default App;
